import {
  Component,
  Input,
  OnChanges,
  SimpleChange,
  Output,
  EventEmitter,
} from "@angular/core";
import { SharedService } from "src/app/utils/services";
@Component({
    selector: "bas-password-strenth-checker",
    templateUrl: "./password-strenth-checker.component.html",
    styleUrls: ["./password-strenth-checker.component.scss"],
    standalone: false
})
export class PasswordStrenthCheckerComponent implements OnChanges {
  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;

  @Input() public passwordToCheck: string;

  @Output() passwordStrength = new EventEmitter<number>();

  private colors = ["red", "orangered", "orange", "yellowgreen"];
  public flags;

  messageColor: string;

  constructor(private sharedService: SharedService) {}

  checkStrength(password: string) {
    // 1
    let force = 0;

    // 2
    const regex = /[$-/:-?{-~!"^_#@`\[\]]/g;
    const lowerLetters = /[a-z]+/.test(password);
    const upperLetters = /[A-Z]+/.test(password);
    const numbers = /[0-9]+/.test(password);
    const symbols = regex.test(password);

    // 3
    this.flags = [lowerLetters, upperLetters, numbers, symbols];

    // 4
    let passedMatches = 0;
    for (const flag of this.flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    // 5
    force += 2 * password.length + (password.length === 20 ? 1 : 0);
    force += passedMatches * 10;

    // 6
    force =
      password.length > 10 && password.length <= 19
        ? Math.min(force, 30)
        : force;
    force = password.length == 10 ? Math.min(force, 20) : force;
    force = password.length < 10 ? Math.min(force, 10) : force;

    // 7
    force = passedMatches === 1 ? Math.min(force, 10) : force;
    force = passedMatches === 2 ? Math.min(force, 20) : force;
    force = passedMatches === 3 ? Math.min(force, 30) : force;
    force = passedMatches === 4 ? Math.min(force, 40) : force;

    return force;
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes.passwordToCheck.currentValue;

    this.setBarColors(4, "#DDD");

    if (password) {
      const pwdStrength = this.checkStrength(password);
      // pwdStrength >= 40 ? this.passwordStrength.emit(true) : this.passwordStrength.emit(false);
      this.sharedService.flag = this.flags;
      this.passwordStrength.emit(pwdStrength);
      const color = this.getColor(pwdStrength);
      this.setBarColors(color.index, color.color);
    }
  }

  private getColor(strength: number) {
    let index = 0;

    if (strength === 10) {
      index = 0;
    } else if (strength === 20) {
      index = 1;
    } else if (strength === 30) {
      index = 2;
    } else if (strength === 40) {
      index = 3;
    } else {
      index = 4;
    }

    this.messageColor = this.colors[index];

    return {
      index: index + 1,
      color: this.colors[index],
    };
  }

  private setBarColors(count: number, color: string) {
    for (let n = 0; n < count; n++) {
      (this as any)["bar" + n] = color;
    }
  }
}
